<template>
	<v-container class="noMargin">
		<v-layout row wrap v-if="objAuthorize.privileges.indexOf('VIEW_STOCK_LEVELS') !== -1">
      <br /><br />
			<v-flex lg12>
				<div class="pageTitle">
					<h2>STOCK LEVELS</h2>
				</div>
			</v-flex>
		</v-layout>
    </v-container>
</template>

<script>

	import { mapGetters } from 'vuex';

	export default {
		name: 'StockHeader',
		data () {
			return {
			}
		  },
		methods: {

		},
		computed: {
			...mapGetters([
              'objAuthorize',
              'priceTableAll'
			])
		}
	}
</script>

<style scoped>
	@import '../shared/assets/css/shared.css'
</style>
